export const SUPPORTED_FILE_FORMATS = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
